import Items from '@/Items.vue';
import { defineComponent } from '@vue/composition-api';
export default defineComponent({
    name: 'ItemList',
    components: { Items: Items },
    props: {
        items: Array
    }
});
